import store from '@/store/index'
(function (doc, win) {
	var docEl = doc.documentElement,
		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
		recalc = function () {	
			//js获取当前的设备大小： document.documesntElement.clientWidth;
			var clientWidth = docEl.clientWidth; //获取设备的宽度
			// 如果没有获取到当前屏幕的大小
			// if (!clientWidth) return;
 
			// if (clientWidth > 1920) {
			// 	docEl.style.fontSize = '100px';
			// } else {
			// 	docEl.style.fontSize = clientWidth * 100 / clientWidth + 'px';
			// 	// 动态修改font-size 100 * (375 / 750) = 50 （iPhone6/7/8为例）
			  docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px';
			//}
		};
	if (!doc.addEventListener) return;
	win.addEventListener(resizeEvt, recalc, false);
	doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window) 